import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { IconButton, Typography } from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { AppSnackbar, Pane, SplitPane, useTimeout } from '@sierralabs/core-ui';
import { GroupDetailContent, GroupList, useFindRootGroups } from '@sierralabs/user-ui';
import { useSiteContext } from '../SiteContext';
import CreateGroupDialog from './dialogs/CreateGroupDialog';
const StyledDiv = styled.div `
  flex: 1;
  display: flex;
  min-height: 0;
  .group-list-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    width: 100%;
    height: 100%;
    .group-list-header {
      display: flex;
      align-items: center;
      padding: 2px 8px 2px 16px;
      .title {
        flex: 1;
      }
    }
    .group-list {
      flex: 1;
    }
  }
  .group-list-pane {
    overflow: hidden;
    min-width: 300px;
  }
  .group-details {
    padding: 16px;
    width: 100%;
    overflow-y: auto;
  }
`;
const GroupAdmin = () => {
    const history = useHistory();
    const containerRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [hover, setHover] = useState();
    const [parent, setParent] = useState();
    const [selected, setSelected] = useState();
    // set groups to undefined by default
    const [groups, setGroups] = useState();
    const [width, setWidth] = useState(0);
    const { editorPath } = useSiteContext();
    const { groups: foundGroups, error, findGroups } = useFindRootGroups();
    const [debounceStyle] = useTimeout();
    const hasSelected = !!selected;
    const setOpenDialog = (open, parent) => {
        setOpen(open);
        setParent(parent);
    };
    const updateGroup = (updated) => {
        const groupId = updated.id;
        if (!groupId) {
            return;
        }
        // create new objects only for updated group and its ancestors
        setGroups(groups => {
            let found = false;
            const update = (group) => {
                if (found) {
                    return group;
                }
                else if (group.id === groupId) {
                    found = true;
                    return Object.assign(Object.assign({}, group), updated);
                }
                const children = (group.children || []).map(update);
                return found ? Object.assign(Object.assign({}, group), { children }) : group;
            };
            return groups === null || groups === void 0 ? void 0 : groups.map(update);
        });
    };
    const findGroupsWithParams = useCallback(() => {
        findGroups({ withChildren: true });
    }, [findGroups]);
    useEffect(() => {
        findGroupsWithParams();
    }, [findGroupsWithParams]);
    useEffect(() => {
        foundGroups && setGroups(foundGroups);
    }, [foundGroups]);
    // only trigger if deselected or selected
    useEffect(() => {
        var _a, _b;
        setWidth(hasSelected ? '70%' : 0);
        const detailsPane = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.group-details-pane');
        const resizer = (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.querySelector('.resizer');
        // add smooth transition
        if (detailsPane) {
            const ms = 250;
            detailsPane.style.transition = `width ${ms}ms cubic-bezier(0.075, 0.82, 0.165, 1)`;
            debounceStyle(() => {
                detailsPane.style.removeProperty('transition');
            }, ms);
        }
        // disable resizer if no selected
        if (resizer === null || resizer === void 0 ? void 0 : resizer.classList.contains('resizer')) {
            if (hasSelected) {
                resizer.style.removeProperty('pointer-events');
            }
            else {
                resizer.style.setProperty('pointer-events', 'none');
            }
        }
    }, [hasSelected, debounceStyle]);
    return (React.createElement(StyledDiv, { ref: containerRef },
        React.createElement(SplitPane, { primary: 'next', className: 'group-admin' },
            React.createElement(Pane, { className: 'group-list-pane' },
                React.createElement("div", { className: 'group-list-container' },
                    React.createElement("div", { className: 'group-list-header' },
                        React.createElement("div", { className: 'title' },
                            React.createElement(Typography, { variant: 'overline' }, "Groups")),
                        React.createElement(IconButton, { onClick: () => setOpenDialog(true) },
                            React.createElement(Add, null))),
                    groups && (React.createElement(GroupList, { groups: groups, hover: hover, selected: selected, onMouseOver: setHover, onMouseOut: () => setHover(undefined), onAddClick: group => setOpenDialog(true, group), onClick: group => {
                            setSelected(group === selected ? undefined : group);
                        } })))),
            React.createElement(SplitPane, { width: width, className: 'group-details-pane' }, selected && (React.createElement("div", { className: 'group-details' },
                React.createElement(GroupDetailContent
                // make sure state is updated when selected group changes
                , { 
                    // make sure state is updated when selected group changes
                    key: selected.id, group: selected, onChange: updateGroup, handleUserRedirect: user => {
                        history.push(`${editorPath}users/${user.id}`);
                    } }))))),
        React.createElement(CreateGroupDialog, { open: open, parent: parent, onCancel: () => setOpenDialog(false), onCreated: () => {
                setOpenDialog(false);
                findGroupsWithParams();
            } }),
        React.createElement(AppSnackbar, { open: !!error, severity: 'error' }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred')));
};
export default GroupAdmin;
//# sourceMappingURL=GroupAdmin.js.map